<template>
  <div ref="nav" class="nav-bar" :class="{'fixed':Object.keys(fixedConfig||{}).length}" :style="style">
    <div class="left h-100">
      <div class="inner-left inner" @click="hanlderLeft">
        <slot name="leftSlot">
          <div class="icon-box">
            <i class="iconfont-new icon-arrow-left" />
          </div>
        </slot>
      </div>
      <div v-if="homeSlot" class="inner-right inner" @click="hanlderHome">
        <slot name="homeSlot">
          <van-icon name="wap-home-o" size="16" />
        </slot>
      </div>
    </div>
    <div class="title h-100">
      <slot name="titleSlot">
        <span>{{ title }}</span>
      </slot>
    </div>
    <div class="right h-100" @click="hanlderRight">
      <slot v-if="rightSlot" name="rightSlot" />
    </div>
  </div>
</template>

<script>
const getRefs = (arg) => {
  const { scrollBox } = arg.$parent.$refs
  if (scrollBox) {
    return scrollBox
  } else {
    return getRefs(arg.$parent)
  }
}
export default {
  name: 'NavBar',
  props: {
    /**
     * 样式信息
     * color 字体颜色
     * bg 背景颜色
     */
    styles: {
      type: Object,
      default: () => {}
    },
    /* 导航滚动配置
    *{
    *  scrollHeight:10,//滚动高度为10px时变化导航背景色
    *  nextStatusBgColor:'red',//变化后的背景色
    *  originBgColor:'#fff'//初始化背景色
    *}
    */
    fixedConfig: {
      type: Object,
      default: () => {}
    },
    // titleText
    title: {
      type: String,
      default: '导航'
    },
    // 左边返回按钮自定义事件
    leftFunction: {
      type: Function,
      default: null
    },
    // 左边home自定义事件
    homeFunction: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      homeSlot: false,
      safeAreaTopHeight: 0,
      rightSlot: false
    }
  },
  computed: {
    style() {
      const { originBgColor } = this.fixedConfig || {}
      const { color = '#333333', bg = '#FFFFFF' } = this.styles || {}
      const { safeAreaTopHeight } = this
      return {
        background: originBgColor || bg,
        color,
        paddingTop: `${safeAreaTopHeight || 0}px`
      }
    }
  },
  watch: {
    fixedConfig: {
      handler(n) {
        if (n) {
          const { originBgColor, nextStatusBgColor } = n
          this.$nextTick(() => {
            if (!n.scrollHeight) {
              return false
            }
            this.scrollBox = getRefs(this)
            this.scrollBox.addEventListener('scroll', (info) => {
              const scrollTop = this.scrollBox.scrollTop
              if (scrollTop > n.scrollHeight) {
                this.$refs.nav.style.background = nextStatusBgColor
              } else {
                this.$refs.nav.style.background = originBgColor
              }
            })
          })
        }
      },
      immediate: true
    }
  },
  created() {
    const { $slots: { homeSlot, rightSlot }} = this
    this.homeSlot = homeSlot
    this.rightSlot = rightSlot
    try {
      const res = JSON.parse(this.$app.getData('screenInfo') || '{}')
      this.safeAreaTopHeight = res.safeAreaTopHeight
    } catch (error) {
      console.error('get safeAreaTopHeight error', error)
    }
  },
  beforeDestroy() {
    this.scrollBox && this.scrollBox.removeEventListener('scroll', () => {}, false)
  },
  methods: {
    hanlderLeft() {
      const { $auth: { env: $env }, $app, leftFunction, $route = {}} = this
      if (leftFunction) {
        leftFunction()
      } else {
        const isIndex = window.history.length
        const { isHome } = $route.meta
        if (isIndex > 1 && !isHome) {
          this.$router.back()
        } else {
          const { inApp = '' } = $env
          if (inApp && $app) {
            this.$app.close()
          } else {
            window.close()
          }
        }
      }
    },
    hanlderHome() {
      const { $auth: { env: $env }, $app, homeFunction } = this
      if (homeFunction) {
        homeFunction()
      } else {
        const { inApp = '' } = $env || {}
        if (inApp && $app) {
          this.$app.goHome()
        } else {
          this.$router.replace({ path: '/' })
        }
      }
    },
    hanlderRight() {
      // if (!this.right) return false
      this.$emit('handlerRight')
    }
  }
}
</script>

<style lang="less" scoped>
.nav-bar{
  z-index: 9;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  font-family: PingFangSC-Medium;
  font-size: 17px;
  // color: #FFFFFF;
  text-align: center;
  font-weight: 500;
  .h-100{
    height: 100%;
    display: flex;
    align-items: center;
  }
  .inner{
    display: flex;
    padding: 0 5px;
  }
  .title{
    width: 60%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 34px;
    font-weight: 600
  }
  .left,.right{
    flex: 1;
  }
  .left{
    position: absolute;
    left: 10px;
    justify-content: flex-start;
    .m-l-10{
      margin-left: 10px;
    }
    .inner-left{
      i{
        font-size: 48px;
      }
    }
  }
  .right{
    justify-content: flex-end;
    font-weight: 400;
    font-family: PingFangSC-Regular;
    position: absolute;
    right: 15px;
  }
}
.fixed{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
</style>
